import styles from "./TeamSettings.module.css";
import React, { useRef } from "react";
import { Team } from "../types";

type TeamNameInputProps = {
  selectedTeam: string;
  setSelectedTeam: (name: string) => void;
  teams: Team[];
};

export const TeamSelect = ({
  selectedTeam,
  setSelectedTeam,
  teams,
}: TeamNameInputProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div ref={containerRef}>
      <div style={{ position: "relative" }}>
        <div className="duration-field-row">
          <p>Team name</p>
          <select
            className={styles["team-settings-invite-form-input"]}
            style={{ marginLeft: "12px" }}
            value={selectedTeam}
            onChange={(event) => setSelectedTeam(event.target.value)}
          >
            {teams.map((team: Team) => {
              return (
                <option
                  key={team.id}
                  value={team.id}
                  style={{ fontWeight: "600" }}
                >
                  {team.name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
};
